export function formatFOIForPaymentFromDraft({ contactInfo, requestInfo, id, secondaryId, status = 'DRAFT' }) {
  if (!contactInfo?.requestor || !requestInfo) {
    return undefined
  }

  return {
    id,
    secondaryId,
    status,
    requestor: {
      isBusiness: contactInfo.requestor.isBusiness || false,
      businessName: contactInfo.requestor.businessName || '',
      firstName: contactInfo.requestor.firstName || '',
      lastName: contactInfo.requestor.lastName || '',
      email: contactInfo.requestor.email || ''
    },
    accessMethod: requestInfo.accessMethod
  }
}

export function formatFOIForPaymentFromBill({ bill, foiStatus }) {
  if (!bill?.foiId) {
    return undefined
  }

  return {
    id: bill.foiId,
    secondaryId: foiStatus?.secondaryId || '',
    status: foiStatus?.status || 'NEW',
    requestor: {
      isBusiness: false,
      businessName: '',
      firstName: 'Applicant',
      lastName: '',
      email: foiStatus?.requestorEmailMasked || ''
    },
    accessMethod: 'DIGITAL'
  }
}
